<div class="card-box-shadow mb-3" [ngClass]="{'readOnly': readOnly}">
  <div class="card-info-header header">
    {{label |translate}}

    <span class="mx-1 link float-right  text-white" *ngIf="field.enableCopy && !disabled &&  !readOnly"
      (click)="copyAddress(field)" style="font-style: italic;">
      {{field.copyAddresslabel || 'Copy'}}
    </span>
    <!-- <span class="float-right" *ngIf="field.enableCopy" (click)="copy(field)">{{field.copyAddresslabel}}</span> -->
  </div>
  <form [formGroup]="form_control">
    <div class="row py-3 px-1">
      <div class="col-md-12">
        <ng-template
          *ngTemplateOutlet="plotSection; context: {section:field,dynamic_form_group:form_control,masters:masters}">
        </ng-template>
      </div>
    </div>
  </form>
</div>




<ng-template #plotSection let-section="section" let-dynamic_form_group="dynamic_form_group" let-masters="masters">
  <div class="row">

    <ng-container *ngFor="let item of (section.addressFields||[]);">
      <!-- <span class="d-none">{{dynamic_form_group.get(section.fieldID).value |
        DynamicFormFieldProcessingPipe :
        dynamic_form_group.get(section.fieldID) : dynamic_form_group : section :
        item :
        (section.multiple?section.multiple_form.get(item.fieldID):
        dynamic_form_group.get(section.fieldID).get(item.fieldID)) :all_form &&
        all_form.value}}
      </span> -->
      <ng-container *ngIf="true">

        <span *ngIf="item.parent_key" extendedFieldsDirective [masters]="masters" [field]="item"
          [form_group]="section.multiple ? section.multiple_form: dynamic_form_group.get(section.fieldID)"
          [form_control]="item.fieldID" [extendedFields]="sec_data[item.parent_key]" [section]="section"></span>
        <ng-container *ngIf="item.lineBreak">
          <div class="col-md-12"></div>
        </ng-container>
        <div [class]="'col-md-' + (item.width || 4)+' '+ item.controlClass"
          *ngIf="!(item && item.UIValidationObjStruct && item.UIValidationObjStruct.hide && item.UIValidationObjStruct.hide.value)">

          <ng-container *ngIf="!readOnly">
            <div class="w-100 h-100 px-2 mb-2">
              <ng-template
                *ngTemplateOutlet="edit_mode; context: {item:item,hide_label:0,width:item.width || 6,section : section,form_group:form_control}">
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngIf="readOnly && !section.multiple">
            <div class="w-100 h-100 px-2 mb-2 readOnly">
              <ng-template
                *ngTemplateOutlet="readOnlyFields; context: {item:item,hide_label:0,width:item.width || 6,section : section,form_group:section.multiple?section.multiple_form: dynamic_form_group.get(section.fieldID)}">
              </ng-template>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #edit_mode let-item="item" let-hide_label="hide_label" let-width="width" let-section="section"
  let-form_group="form_group">
  <form [formGroup]="form_group" [id]="section.fieldID + item.fieldID">
    <ng-container *ngIf="item.dataTypeId == 1">
      <!-- TEXT -->
      <mat-form-field floatLabel='always'>
        <mat-label>
          <ng-container *ngIf="!hide_label">
            <span [title]="item.label | translate">
              {{item.label | translate}}
            </span>
          </ng-container>
        </mat-label>
        <input matInput [formControlName]="item.fieldID"
          (keyup)="item.transform ? transformFn(form_group.get(item.fieldID),item.transform):null"
          [placeholder]="item.placeholder"
          [readonly]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || disabled )? true : false"
          [maxlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_length  && item.UIValidationObjStruct.max_length.value ?  item.UIValidationObjStruct.max_length.value: 999999999"
          [minlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_length  && item.UIValidationObjStruct.min_length.value ?  item.UIValidationObjStruct.min_length.value: 0">

        <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('required');else maxlength">
          Field is mandatory
        </mat-error>
        <ng-template #maxlength>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('maxlength');else minlength">
            Maximum length ({{item.UIValidationObjStruct.max_length.value || 999999999}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlength>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('minlength'); else maxvalue">
            Minimum length must be ({{item.UIValidationObjStruct.min_length.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #maxvalue>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('max');else minvalue">
            Value must be lesser than ({{item.UIValidationObjStruct.max_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #minvalue>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('min'); else pattern">
            Value must be greater than ({{item.UIValidationObjStruct.min_value.value || 999999}})
          </mat-error>
        </ng-template>
        <ng-template #pattern>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 2">
      <!-- NUMBER -->
      <mat-form-field floatLabel="always">
        <mat-label>
          <ng-container *ngIf="!hide_label">
            <span [title]="item.label | translate">
              {{item.label | translate}}
            </span>
          </ng-container>

        </mat-label>
        <input matInput type="number" [formControlName]="item.fieldID" [placeholder]="item.placeholder"
          [maxlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_length  && item.UIValidationObjStruct.max_length.value ?  item.UIValidationObjStruct.max_length.value: 999999999"
          [readonly]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
          [minlength]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_length  && item.UIValidationObjStruct.min_length.value ?  item.UIValidationObjStruct.min_length.value: 0">
        <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('required');else maxlengthnum">
          Field is mandatory
          <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </mat-error>
        <ng-template #maxlengthnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('maxlength');else minlengthnum">
            Maximum length ({{item.UIValidationObjStruct.max_length.value || 999999999}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlengthnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('minlength'); else maxvaluenum">
            Minimum length must be ({{item.UIValidationObjStruct.min_length.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #maxvaluenum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('max');else minvaluenum">
            Value must be lesser than ({{item.UIValidationObjStruct.max_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #minvaluenum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('min'); else patternnum">
            Value must be greater than ({{item.UIValidationObjStruct.min_value.value || 0}})
          </mat-error>
        </ng-template>
        <ng-template #patternnum>
          <mat-error *ngIf="form_group && form_group.get(item.fieldID).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 3">
      <!-- DATE -->
      <tm-date-picker [form]="form_group" [controlName]="item.fieldID"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?  true: false"
        [minValue]="item.UIValidationObjStruct && item.UIValidationObjStruct.min_value  && item.UIValidationObjStruct.min_value.value ? item.UIValidationObjStruct.min_value.value : null "
        [maxValue]="item.UIValidationObjStruct && item.UIValidationObjStruct.max_value  && item.UIValidationObjStruct.max_value.value ? item.UIValidationObjStruct.max_value.value : null "
        [label]="item.label" [value]="form_group.value && form_group.value[item.fieldID]"
        [placeholder]="item.placeholder" (onChange)="optionSelected($event,item.expression,form_group,item)"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </tm-date-picker>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 4">
      <!-- DATE & TIME -->
      <tm-date-time-picker-t2 [form]="form_group" [controlName]="item.fieldID"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
        [label]="item.label" [value]="form_group.value &&form_group.value[item.fieldID]"
        [placeholder]="item.placeholder"></tm-date-time-picker-t2>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 5">
      <!-- SINGLE FILE -->
      <tm-files-v2 [form_group]="form_group"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
        [form_control]="item.fieldID" [label]="item.label" [style]="{'margin-bottom':'0px'}" [multiple]="0"
        [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
        [result]="form_group.value && form_group.value[item.fieldID]"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </tm-files-v2>

    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 6">
      <!-- MULTIPE FILES -->
      <tm-files-v2 [form_group]="form_group"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? true: false"
        [style]="{'margin-bottom':'0px'}" [form_control]="item.fieldID" [label]="item.label" [multiple]="1"
        [supported_files]="item.documentValidation && item.documentValidation.accepetedTypes ? item.documentValidation.accepetedTypes : ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', 'ogv', 'wav' , 'amr' , 'ogg' , 'xls' , 'svg' ]"
        [result]="form_group.value &&form_group.value[item.fieldID]"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </tm-files-v2>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 7">
      <app-phone-number [hide_label]="item.hide_label" [placeholder]="item.placeholder"
        [options]="item.suggestedValues || item.list" [options_data]="item.option_form_control && item.option_form_control !=''?form_group.value
                 &&form_group.value[item.option_form_control] :null " [maxLength]="item.maxLength"
        [option_form_control]="item.option_form_control" [form]="form_group" [controlName]="item.fieldID"
        [label]="item.label" [data]="form_group.value
                &&form_group.value[item.fieldID]" [pattern_desc]="'^[0-9]*$'" [required]="1">
      </app-phone-number>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 8">
      <!-- {{form_group.value | json}} -->
      <tm-select
        [options]="item.isDataMaster ? dynamic_form_group.value[item.isDataMaster.options_key]  : item.suggestedValues ||masters[item.masterPropName] ||[]"
        [id_property]="item.id_property || 'id'" [title_property]="item.title_property || 'title'"
        [data]="form_group.value[item.fieldID]" [form_group]="form_group" [donot_autoselect]="1"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [form_control]="item.fieldID" [label]="item.label" [hide_label]="item.hide_label"
        [enable_virtual_scroll]="item.enable_virtual_scroll"
        [no_data_found_message]="item.no_data_found_message || 'Type here to search'"
        [label_action_title]="item.label_action_title" [label_action_type]="item.label_action_type || null"
        (fetchEntries)="fetchMasterEntries($event,item.api_route,masters,item,section)"
        [design_pattern]="item.design_pattern"
        (suffix_btn_listner)="managePresentLocations($event,masters,item,section,form_group)"
        [label_action_title]="item.label_action_title" [label_action_type]="item.label_action_type"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [label_overflow]="item.label_overflow" (selected_obj)="optionSelected($event,item.expression,form_group,item)">
      </tm-select>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 9">
      <tm-multi-select
        [options]="item.isDataMaster ? dynamic_form_group.value[item.isDataMaster.options_key]  : item.suggestedValues ||masters[item.masterPropName] ||[]"
        [id_property]="item.id_property || 'id'" [title_property]="item.title_property || 'title'"
        [data]="form_group.value &&form_group.value[item.fieldID]" [form_group]="form_group"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [form_control]="item.fieldID" [hide_label]="item.hide_label" [label_overflow]="item.label_overflow"
        [label]="item.label" (selected_obj)="optionSelected($event,item.expression,form_group,item)"
        [no_data_found_message]="item.no_data_found_message || 'Type here to search'"
        [enable_virtual_scroll]="item.enable_virtual_scroll"
        (fetchEntries)="fetchMasterEntries($event,item.api_route,masters,item,section)">
      </tm-multi-select>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 11 && item.fieldID && item.numberControl">
      <app-dynamic-phone-number [isd_formControl]="item.fieldID" [form]="form_group" [masters]="masters"
        [isd_label]="item.label" [isd_placeholder]="item.placeholder"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [mobile_number_placeholder]="item.numberControlplaceholder" [mobile_number_form_control]="item.numberControl">
      </app-dynamic-phone-number>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 12">
      <app-radio [form]="form_group" [controlName]="item.fieldID" [label]="item.label"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ? 1 : 0"
        [options]="item.suggestedValues || masters[item.masterPropName]">
      </app-radio>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 13">
      <tm-checkbox [label]="item.label" [form_group]="form_group" [form_control]="item.fieldID"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </tm-checkbox>
      <!-- [data]="form_group.value[item.fieldID]" -->
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 14">
      <tm-digital-signature [form_group]="form_group" [height]="item.height || 150" [form_control]="item.fieldID"
        [field]="item"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">

      </tm-digital-signature>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 15">
      <tm-digital-signature [form_group]="form_group" [field]="item">

      </tm-digital-signature>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 17">
      <tm-dynamic-checklist [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">

      </tm-dynamic-checklist>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 18">
      <label class="form-check-label" for="exampleCheck1" *ngIf="item.paragraphLabel">
        <span [innerHTML]="item.paragraphLabel"></span>
      </label>
      <app-checkbox [form_group]="form_group" [controlName]="item.fieldID" [field]="item" [label]="item.label"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [mandatory]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?true:false">
      </app-checkbox>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 19">
      <tm-month-year [form]="form_group" [controlName]="item.fieldID" [float_label]="'always'"
        [value]="form_group.value[item.fieldID]" [label]="item.label|translate" [placeholder]="item.placeholder"
        (onChange)="optionSelected($event,item.expression,form_group,item)"
        [required]="item.UIValidationObjStruct &&  item.UIValidationObjStruct.mandatory ? item.UIValidationObjStruct.mandatory.value : 0"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </tm-month-year>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 20">
      <tm-dynamic-assessment [form_group]="form_group" [masters]="masters" [field]="item" [section]="section"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">

      </tm-dynamic-assessment>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 21">
      <app-html-text-editor-v2 [form]="form_group" [controlName]='item.fieldID' [label]="item['label'] |translate"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [required]="item.UIValidationObjStruct && item.UIValidationObjStruct.mandatory  && item.UIValidationObjStruct.mandatory.value ?true:false">
      </app-html-text-editor-v2>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId == 22">
      <mat-star-rating [form_group]="form_group" [form_control]="item.fieldID"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false"
        [rating]="form_group.value[item.fieldID] ||1">
      </mat-star-rating>
    </ng-container>

    <ng-container *ngIf="item.dataTypeId == 24">
      <app-confirm-password [form]="form_group" [controlName]="item.fieldID" [float_label]="'always'" [field_obj]="item"
        [value]="form_group.value[item.fieldID]" [label]="item.label|translate" [placeholder]="item.placeholder"
        (onChange)="optionSelected($event,item.expression,form_group,item)" [type]="item.type"
        [required]="item.UIValidationObjStruct &&  item.UIValidationObjStruct.mandatory ? item.UIValidationObjStruct.mandatory.value : 0"
        [disabled]="(item && item.UIValidationObjStruct&& item.UIValidationObjStruct.disabled  && item.UIValidationObjStruct.disabled.value == 1 || (disabled)) ? true : false">
      </app-confirm-password>
    </ng-container>
  </form>
</ng-template>


<ng-template #readOnlyFields let-item="item" let-hide_label="hide_label" let-width="width" let-section="section"
  let-form_group="form_group">
  <label class="d-block">
    <ng-container>
      <span [title]="item.label | translate">
        {{item.label | translate}}
      </span>
    </ng-container>
  </label>

  <span [id]=" 'tallite-td'+ item.fieldID" class="d-block word-wrap-break min-height-18 text-bold"
    [ngClass]="{'pointer link':item.functionName && item.functionName!=''}"
    [ngStyle]=" item.gridStyle ? (item.gridStyle |checkStyle : sec_data:item):null ">
    <!-- <div [ngStyle]="{'width': item.gridWidth > 20 ? item.width+'px' : '100px'}"
      class="item-header tallint-data-grid " [ngClass]="{'text-right right-me-lelo':item.dataTypeId=='int'}"
      [class]="item.cell_class" style="border-right: 3px solid transparent;"> -->
    <ng-container *ngIf="item.dataTypeId ==1;else checkDate">
      <span class="margin" [title]="sec_data[item.fieldID]">
        <span [innerHTML]='sec_data[item.fieldID]| HTMLFormatter'>
        </span>
      </span>
    </ng-container>
    <ng-template #checkDate>
      <ng-container *ngIf="item.dataTypeId ==3;else checkDateTime">
        <span class="item-title" [title]="(sec_data[item.fieldID])  | LocalDatePipe">
          {{(sec_data[item.fieldID])| LocalDatePipe}}
        </span>
      </ng-container>
    </ng-template>
    <ng-template #checkDateTime>
      <ng-container *ngIf="item.dataTypeId ==4;else checkTime">
        <span class="item-title" [title]="sec_data[item.fieldID]  | LocalDateTimePipe">
          {{(sec_data[item.fieldID]) | LocalDateTimePipe}}
        </span>
      </ng-container>
    </ng-template>
    <ng-template #checkTime>
      <ng-container class="item-title" *ngIf="item.dataTypeId =='time';else checknvarchar;">
        <span [title]="sec_data[item.fieldID]  | LocalDateTimePipe">
          {{(sec_data[item.fieldID]) | UtcToLocalTime | date: 'h:mm a'}}
        </span>
      </ng-container>
    </ng-template>
    <ng-template #checknvarchar>
      <ng-container *ngIf="item.dataTypeId ==1;else checkvarbinary;">
        <span class="margin item-header">
          <span class="item-title" [innerHTML]='sec_data[item.fieldID]| HTMLFormatter'>
          </span>
        </span>
      </ng-container>
    </ng-template>
    <ng-template #checkvarbinary>
      <ng-container *ngIf="(item.dataTypeId ==5|| item.dataTypeId ==6 );else checkHtmlTemplate;">

        <ng-container *ngFor="let file of sec_data[item.fieldID]">
          <a class="item-title link  d-block" target="_blank" [href]="storage_url + file.cdnPath"
            [attr.download]="file.fileName">
            {{file.fileName}}
          </a>
        </ng-container>
        <!-- {{(sec_data[item.fieldID]) | DynamicFilesTitlePipe}} -->

      </ng-container>
    </ng-template>
    <ng-template #checkHtmlTemplate>
      <ng-container *ngIf="item.dataTypeId ==10;else checkPhoneNumber;">
        <div class="margin"
          [innerHTML]="((item.style |checkTemplate : sec_data:item)| HTMLFormatter)|TMsafeHTML :'html'">
        </div>
      </ng-container>
    </ng-template>

    <ng-template #checkPhoneNumber>
      <ng-container *ngIf="item.dataTypeId ==11;else dropdown;">
        <div class="margin">

          {{ sec_data[item.fieldID] | DynamicPipe: masters[item['masterPropName']] :'id':'title'}}
          {{sec_data[item.numberControl]}}
        </div>
      </ng-container>
    </ng-template>


    <ng-template #dropdown>
      <ng-container *ngIf="(item.dataTypeId ==8 ||item.dataTypeId ==9);else tmCheckbox;">
        <ng-container *ngIf=" sec_data[item.fieldID]">
          {{ sec_data[item.fieldID] | DynamicPipe: masters[item['masterPropName']] :'id':'title'}}
        </ng-container>
      </ng-container>

    </ng-template>

    <ng-template #tmCheckbox>
      <ng-container *ngIf="item.dataTypeId ==13;else monthYear;">
        <ng-container *ngIf="sec_data[item.fieldID]">
          <i class="fa checkbox-icons fa-check-square-o"></i>
        </ng-container>

      </ng-container>

    </ng-template>

    <ng-template #monthYear>
      <ng-container class="item-title" *ngIf="item.dataTypeId ==19;else address;">
        <span [title]="sec_data[item.fieldID]  | UtcToLocalTime | date: 'MMM-yyyy'">
          {{(sec_data[item.fieldID]) | UtcToLocalTime | date: 'MMM-yyyy'}}
        </span>
      </ng-container>
    </ng-template>

    <ng-template #address>
      <ng-container class="item-title" *ngIf="item.dataTypeId ==-1;else noDataType;">
        <app-tm-address [masters]="masters" [form_control]="form_group.get(item.fieldID)" [readonly]="false"
          [label]="item.label" [field]="item" [dynamic_form_group]="form_group" [readOnly]="readOnly"
          [disabled]="(readonly) ? true : false" [sec_data]="form_group.get(item.fieldID).value">
        </app-tm-address>



        <!-- <span [title]="sec_data[item.fieldID]  | UtcToLocalTime | date: 'MMM-yyyy'">
          {{(sec_data[item.fieldID]) | UtcToLocalTime | date: 'MMM-yyyy'}}
        </span> -->
      </ng-container>
    </ng-template>

    <ng-template #noDataType>
      <span [title]="sec_data[item.fieldID]">
        {{sec_data[item.fieldID]}}
      </span>
    </ng-template>
  </span>

</ng-template>